import React from 'react';
import { Component } from '@poa/core';
import RouteLoading from '../components/route-loading';
import Navbar from '../components/navbar';

import ChatsSidebar from '../components/chats/chats-sidebar';
import ChatsUserSidebar from '../components/chats/chats-user-sidebar';
import ChatContent from '../components/chats/chats-content';


class ChatsPage extends React.Component {
    store; // injected by Poa

    render() {
        return (
            <RouteLoading
                meta={this.store.chats.meta}
                render={() => {
                    return (
                        <div className='general-page'>
                            <Navbar />

                            <div className='under-navbar-content-fixed'>
                                <div className='general-page__container'>
                                    <ChatsSidebar />
                                    <ChatsUserSidebar />
                                    <ChatContent />
                                </div>
                            </div>
                        </div>
                    )
                }}
            />
        );
    }
}

export default Component({ namespaces: ['chats'] })(ChatsPage);
